import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { SentryUtils } from '@pbt/pbt-ui-components'

import { getCurrentBusiness, getCurrentUser } from '~/store/reducers/auth'
import { getRolesMap } from '~/store/reducers/roles'
import { resetLogRocketUser, setLogRocketUser } from '~/utils/LogRocket'
import useIsAuthenticated from '~/utils/useIsAuthenticated'

const MonitoringWidget = () => {
  const user = useSelector(getCurrentUser)
  const business = useSelector(getCurrentBusiness)
  const roles = useSelector(getRolesMap)
  const userRoles =
    user?.businessToRoleList
      ?.filter((role) => role.business === business?.id)
      .map((role) => roles[role.role]?.name) || undefined

  const { isAuthenticated, isAuthenticating } = useIsAuthenticated()

  useEffect(() => {
    if (isAuthenticated) {
      setLogRocketUser(user, business, userRoles)
      SentryUtils.setContext(business, user)
    } else if (!isAuthenticating) {
      resetLogRocketUser()
    }
  }, [user, isAuthenticated, business, userRoles])

  return null
}

export default MonitoringWidget
